<template>
  <el-form class="form custom-form" v-if="form" label-width="200px" :label-position="formLabelPosition">
    <div class="heading"><h3 v-if="form.heading">{{form.heading}}</h3></div>
    <el-form-item :label="field.name" :error="errors[field.id]" v-for="field, i in form.form_fields">
      <el-input :placeholder="field.placeholder" v-model="formData[field.id]" :type="field.input_type" v-if="inputTypes.indexOf(field.input_type) > -1"></el-input>
      <el-select v-model="formData[field.id]" v-if="field.input_type == 'dropdown'">
        <el-option
          v-for="choice in field.choices"
          :key="choice.id"
          :label="choice.name"
          :value="choice.name">
        </el-option>
      </el-select>
      <p class="description" v-if="field.description">{{field.description}}</p>
    </el-form-item>
  </el-form>
</template>

<script>
  import { mapState } from 'vuex'
  import api from '../api/api'
  import formMixin from '../mixins/formMixin'

  export default {
    mixins: [formMixin],
    props: ['scenarioId'],
    computed: {
      ...mapState({
        order: state => state.order.order,
        bookingFormData: state => state.booking.options.formData
      })
    },
    methods: {
      validate() {
        this.errors = {}
        if (this.form == null)
          return true
        let isValid = true
        this.form.form_fields.forEach((field) => {
          if (field.is_required && !this.formData[field.id]) {
            this.errors[field.id] = "is required"
            isValid = false
          }
        })
        return isValid
      },
      sync() {
        let formData = {}
        this.form.form_fields.forEach((field) => {
          formData[field.id] = this.formData[field.id]
        })
        this.$store.commit("booking/setFormData", formData)
      }
    },
    data() {
      return {
        formData: {},
        errors: {},
        form: null,
        inputTypes: [
          'text',
          'textarea'
        ]
      }
    },
    created() {
      this.formData = Object.assign({}, this.bookingFormData)
      //this.$store.dispatch('forms/getForm', { scenario_id: this.scenarioId })
      api.getForm({scenario_id: this.scenarioId}).then((response) => {
        this.form = response.data
      })
    }
  }
</script>
